/* import __COLOCATED_TEMPLATE__ from './mobile-unsupported-with-image.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

/**
 * `MobileUnsupportedWithImage` is designed to be a reusable component that can be included in:
 *   - The mobile unsupported page
 *   - A milestone in the setup guide blade if all the action items of the milestone are not supported on mobile web
 *   - The modal dialog that is opened after tapping on an action item that is not supported on mobile
 *
 * @example
 * <MobileUnsupportedWithImage @title="Title"
 *                             @subtitle="Subtitle"
 *                             @primaryCtaLabel="Open Square for Retail App"
 *                             @onPrimaryCtaTap={{this.primaryCtaAction}}
 *                             @secondaryCtaLabel="Switch to desktop site"
 *                             @onSecondaryCtaTap={{this.secondaryCtaAction}} />
 *
 * @param {string} title - The title's copy.
 * @param {string} subtitle - The subtitle's copy.
 * @param {string} primaryCtaLabel - The primary CTA's label.
 * @param {string} onPrimaryCtaTap - The function that will be called when the primary CTA is clicked/tapped on.
 * @param {string} secondaryCtaLabel - The secondary CTA's label
 * @param {string} onSecondaryCtaTap - The function that will be called when the secondary CTA is clicked/tapped on.
 * @param {string} [imageDirectory='/@dashboard/shared-ui/images/rtl'] - The directory the image is located in.
 * @param {string} [imageName='rtl-mobile-unsupported'] - The name of the image.
 * @param {string} [imageDescription='Retail mobile unsupported'] - Descriptive text for the image (`alt` text).
 * @param {string} [imageExtension='png'] - The extension to be used when generating the image path.
 */
let MobileUnsupportedWithImage = (_class = class MobileUnsupportedWithImage extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "i18n", _descriptor3, this);
  }
  get imageData() {
    return {
      directory: this.args.imageDirectory ?? '/@dashboard/shared-ui/images/rtl',
      description: this.args.imageDescription ?? 'Retail mobile unsupported',
      name: this.args.imageName ?? 'rtl-mobile-unsupported',
      extension: this.args.imageExtension ?? 'jpg'
    };
  }
  tapPrimaryAction() {
    this.args.onPrimaryCtaTap?.();
  }
  tapSecondaryAction() {
    this.args.onSecondaryCtaTap?.();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "tapPrimaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "tapPrimaryAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tapSecondaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "tapSecondaryAction"), _class.prototype)), _class);
export { MobileUnsupportedWithImage as default };